import { Fragment, useState } from "react"
import { Chip, Collapse, IconButton, Stack, TableCell, TableRow, Typography } from "@mui/material"
import Iconify from "minimals-template/components/Iconify"
import { If } from "lib/@components/switch"

/**
 * One removed demand as a table row, with the explanation behind an expander. The reason text
 * is long by necessity — it has to say what to do about it — but a client with a dozen removals
 * should still fit on a screen.
 */
export function RemovedRow({ item: entry }) {
    const [open, setOpen] = useState(false)

    return (
        <Fragment>
            <TableRow sx={{ "& > *": { borderBottom: "unset" } }} data-cy={`access-removed-${entry.demand}`}>
                <TableCell>
                    <IconButton
                        aria-label={open ? "Hide details" : "Show details"}
                        size="small"
                        onClick={toggle}
                        data-cy="access-removed-info"
                    >
                        <Iconify icon={open ? "mdi:chevron-down" : "mdi:chevron-right"} />
                    </IconButton>
                </TableCell>
                <TableCell>
                    <Typography variant="body2" sx={{ fontFamily: "monospace" }}>
                        {entry.demand}
                    </Typography>
                </TableCell>
                <TableCell>
                    <Chip size="small" color="error" variant="outlined" label={entry.removedBy} />
                </TableCell>
                <TableCell>
                    <Typography variant="body2" color="text.secondary">
                        {(entry.sources ?? []).join(", ") || "—"}
                    </Typography>
                </TableCell>
                <TableCell>
                    <Stack direction="row" spacing={0.5} useFlexGap flexWrap="wrap">
                        <If value={entry.wasOverridden}>
                            <Chip size="small" color="warning" label="overridden" />
                        </If>
                        <If value={entry.bypassable}>
                            <Chip size="small" variant="outlined" label="forceable" />
                        </If>
                    </Stack>
                </TableCell>
            </TableRow>
            <TableRow>
                <TableCell colSpan={5} sx={{ py: 0 }}>
                    <Collapse in={open} unmountOnExit>
                        <Stack spacing={0.5} py={1.5} pl={1}>
                            <Typography variant="body2">{entry.reason}</Typography>
                            <If value={entry.bypassable}>
                                <Typography variant="caption" color="text.secondary">
                                    An override can force this through if the grant explicitly bypasses{" "}
                                    {entry.removedBy}.
                                </Typography>
                            </If>
                        </Stack>
                    </Collapse>
                </TableCell>
            </TableRow>
        </Fragment>
    )

    function toggle() {
        setOpen((current) => !current)
    }
}
